import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  Dimensions,
  ImageCroppedEvent,
  ImageCropperComponent,
  ImageTransform,
  LoadedImage,
} from 'ngx-image-cropper';
import { CommonApiService } from '@services/common/common-api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';
import { Media } from '@models/media/media.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Size } from '@models/common/size.model';
import { ToastrService } from 'ngx-toastr';
import { base64ToFile2 } from '@functions/files';
import { first } from 'lodash';

@Component({
  selector: 'app-crop-modal',
  templateUrl: './crop-modal.component.html',
  styleUrls: ['./crop-modal.component.scss'],
  providers: [
    { provide: 'API_SERVICE', useValue: 'communities' },
    CommonApiService,
  ],
})
export class CropModalComponent {
  @Input() media!: Media;
  @Input() size: Size;

  @ViewChild(ImageCropperComponent, { static: true })
  imageCropper: ImageCropperComponent;
  @Output() emitter: EventEmitter<Media> = new EventEmitter();

  private original: LoadedImage;
  private cropped: ImageCroppedEvent;

  //Rotation
  step = 1;
  rotateUrl: string | null = '';
  rotation = 0;

  constructor(
    private api: CommonApiService,
    public modal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService
  ) {}

  imageCropped(event: ImageCroppedEvent) {
    this.cropped = event;
  }
  close() {
    this.modal.dismiss('Cross click');
  }

  success() {
    if (
      this.original.original.size.width !== this.cropped.width ||
      this.original.original.size.height !== this.cropped.height
    ) {
      base64ToFile2(
        `${this.cropped.base64}`,
        `${this.media.name}`,
        'image/jpg'
      ).then(file => {
        if (file) {
          this.media.id = undefined;
          this.media.url = null;
          this.media.file = file;
          this.emitter.emit(this.media);
        }
      });
    } else {
      this.emitter.emit(this.media);
    }
    this.close();
  }

  imageLoaded(event: LoadedImage) {
    this.original = event;
  }

  // ROTATION--------------------------

  rotateLeft() {
    this.rotation === 360 ? (this.rotation = 90) : (this.rotation += 90);
  }
  rotateRight() {
    this.rotation === 0 ? (this.rotation = 270) : (this.rotation -= 90);
  }
  onSubmitRotation() {
    const rotationData = {
      url: this.media.url,
      rotateDeg: this.rotation,
    };

    this.api
      .form<Media[]>(`media/upload-file-from-url`, rotationData)
      .subscribe({
        error: (errorEventAdded: HttpErrorResponse) => {
          const errorFields = Object.keys(errorEventAdded?.error.errors || {});
          if (errorFields.length > 0) {
            errorFields.forEach((field: string) => {
              this.toastr.error(
                errorEventAdded?.error.errors[field] || 'An error occurred.'
              );
            });
          } else {
            this.toastr.error('An error occurred. Please try again!');
          }
        },
        next: response => {
          if (first(response)?.children) {
            first(response)?.children?.map((child: Media) => {
              if (child.size == 'CUSTOM') {
                this.rotateUrl = child.url;
              }
            });
            this.step = 2;
          }
        },
      });
  }
}
